module.exports = __webpack_public_path__ + "static/media/md-podium.87a7b8d2.svg";